import { Group as GroupIcon } from "@mui/icons-material";
import { Badge, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { last } from "lodash-es";
import moment from "moment";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Avatar } from "../../commons/Avatar.js";
import { useBubbleContext } from "../../commons/hooks/useBubbleContext.js";
import { ProfileListItemButton } from "../../commons/ProfileListItem.js";
import { ChannelListItemFragment } from "./Channels.generated.js";

interface Props {
  channelId?: string;
  channel: ChannelListItemFragment;
  divider?: boolean;
}

export const ProjectChannelListItem = ({
  channelId,
  channel,
  divider = true,
}: Props) => {
  const { bubble } = useBubbleContext();
  const bubbleAmount = bubble.perChannel[channel.id] || 0;

  const { t } = useTranslate("Channel");

  // const otherParticipants = channel.participants.edges
  //   .map(e => e.node)
  //   .filter(u => u.id !== currentUser.id);

  const lastMessage = useMemo(() => {
    const message = last(channel.messages.edges);
    if (!message) return undefined;
    return message.node.text;
  }, [channel.messages.edges]);

  const lastDate = useMemo(() => {
    const message = last(channel.messages.edges);
    if (!message) return undefined;
    return moment(message.node.createdAt).fromNow();
  }, [channel.messages.edges]);

  return (
    <ProfileListItemButton
      avatar={
        <Badge
          overlap="circular"
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          color="error"
          badgeContent={bubbleAmount}
        >
          {/* {channel.type === "USER2USER" ? null : ( */}
          {/* <UserAvatar userAvatar={otherParticipants[0]} /> */}
          <Avatar
            type="circle"
            size="m"
            icon={<GroupIcon />}
            url={channel.logo.url}
          />
          {/* )} */}
        </Badge>
      }
      badge={
        lastDate ? (
          <Typography
            variant="caption"
            color="secondary"
            noWrap
            component="div"
          >
            {lastDate}
          </Typography>
        ) : undefined
      }
      primary={
        channel.type === "PRJ_COMMENTS" ? t("Project comments") : channel.label
      }
      secondary={lastMessage}
      listItemProps={{
        divider,
        selected: channel.id === channelId,
        component: Link,
        to:
          channel.type !== "USER2USER" ? `${channel.id}` : `u2u/${channel.id}`,
        "data-testid": "chat-channel-list-item",
      }}
    />
  );
};
